import { createFileRoute } from '@tanstack/react-router';

import { AgencyBilling } from '@/components/agency/billing/agency-billing';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute('/_authenticated/agency/billing')({
  loader: () => loadNamespaces('agency'),
  staticData: {
    title: 'route.agency_billing.title',
  },
  component: AgencyBilling,
});
